import { Text } from '@/components/ui/text';
import { DESIGN_TOKENS } from '@/lib/design/theme';
import * as React from 'react';
import { ActivityIndicator, View } from 'react-native';

export function PulseLoadingState() {
  return (
    <View className="mx-5 rounded-[28px] border border-border bg-surface-overlay px-5 py-6">
      <View className="flex-row items-center gap-3">
        <View className="size-11 items-center justify-center rounded-full bg-primary/15">
          <ActivityIndicator color={DESIGN_TOKENS.colors.accent} />
        </View>
        <View className="min-w-0 flex-1 gap-1">
          <Text className="text-[18px] font-semibold tracking-tight text-foreground">
            Checking your Pulse
          </Text>
          <Text variant="small" className="text-muted-foreground">
            Gathering alerts first, then the social activity around your events.
          </Text>
        </View>
      </View>

      <View className="mt-5 gap-2">
        <View className="h-3 w-4/5 rounded-full bg-surface-raised" />
        <View className="h-3 w-3/5 rounded-full bg-surface-raised/80" />
      </View>
    </View>
  );
}
